export function isLocalUrl(url: string | undefined | null): boolean {
   if (!url) {
      return false;
   } else {
      return url === "/" || !!url.match(/^~?\/[^\/\\]/);
   }
}